import { IHome } from "@src/components/Home";
import React from "react";
import { useQuery } from "@apollo/client";
import ClientOnly from "@src/components/ClientOnly";
import Floater from "../Floater";
import Footer from "../Footer";
import Vendors from "../Vendors";
import Parts from "../Parts";
import FAQ from "../FAQ";
import Recommendations from "../Recommendations";
import Backstory from "../Backstory";
import MarqueeComp from "../MarqueeComp";
import Quotes from "../Quotes";
import Masonry from "../Masonry";
import Hero from "../Hero";
import AsoEbi from "../AsoEbiLink";
import { useEventParts } from "@src/hooks/useEventParts";
import { useHome } from "@src/hooks/useHome";
import WeddingParty from "../WeddingParty";
import {
  Event_PreferencesQuery,
  Event_PreferencesQueryVariables,
} from "@src/@types/api.d";
import { GetEventPreferences } from "@src/graphql/queries";

const HomeT11: React.FC<IHome> = ({
  slug,
  eventBySlugData,
  eventId,
  eventPartsData,
  backStoryData,
  eventVendorData,
  albumDetailsData,
  heroImageData,
  hasWallet,
  getEventStreamersData,
  liveSchedules,
  eventUuid,
  weddingPartyData,
  faqData,
  recommendationData,
  inviteResult: initialInviteResult,
}) => {
  const {
    accessToken,
    inviteResult,
    getAsoebiData,
    isCashGiftSetup,
    isInvitedToEvent,
  } = useHome({
    slug,
    eventBySlugData,
    eventId,
    eventPartsData,
    backStoryData,
    eventVendorData,
    albumDetailsData,
    heroImageData,
    hasWallet,
    getEventStreamersData,
    liveSchedules,
    eventUuid,
    weddingPartyData,
    faqData,
    recommendationData,
    inviteResult: initialInviteResult,
  });

  const { data: eventPreferencesData } = useQuery<
    Event_PreferencesQuery,
    Event_PreferencesQueryVariables
  >(GetEventPreferences, {
    variables: { eventId: eventUuid as string },
    skip: !eventUuid,
  });

  const shouldShowFaq = eventPreferencesData?.event_preferences?.faq ?? false;
  const shouldShowRecommendations =
    eventPreferencesData?.event_preferences?.recommendations ?? false;
  const { parts } = useEventParts({
    eventPartsData,
    liveSchedules,
    eventTimezone: eventBySlugData?.eventBySlug?.eventTimezone,
    isInvitedToEvent,
  });

  return (
    <>
      <ClientOnly>
        <Floater
          accessToken={accessToken}
          eventId={eventId}
          eventUuid={eventUuid}
          slugData={eventBySlugData}
          hasWallet={hasWallet}
          getEventStreamersData={getEventStreamersData}
          liveSchedules={liveSchedules}
          access_control={
            eventBySlugData?.eventBySlug?.event_preference?.access_control ??
            false
          }
          qr_code={inviteResult?.signupByInviteLink?.invitation?.qr_code ?? ""}
          getAsoebiData={getAsoebiData}
          admits={inviteResult?.signupByInviteLink?.invitation?.admits ?? 1}
          invitation={inviteResult?.signupByInviteLink?.invitation}
          isInvitedToEvent={isInvitedToEvent}
        />
        <Hero
          heroImageData={heroImageData}
          eventId={eventId}
          slugData={eventBySlugData}
        />

        <Masonry
          eventSlug={slug}
          eventId={eventId}
          albumDetailsData={albumDetailsData}
        />

        <Backstory eventId={eventId} backStoryData={backStoryData} />

        <WeddingParty eventId={eventId} weddingPartyData={weddingPartyData} />

        <Parts
          liveSchedules={liveSchedules}
          eventId={eventId}
          parts={parts}
          eventPartsData={eventPartsData}
          eventTimezone={eventBySlugData?.eventBySlug?.eventTimezone}
        />

        {shouldShowFaq && faqData && (
          <FAQ eventId={eventId} faqData={faqData} />
        )}
        {shouldShowRecommendations && recommendationData && (
          <Recommendations
            eventId={eventId}
            recommendationData={recommendationData}
          />
        )}

        <Quotes albumDetailsData={albumDetailsData} />

        {accessToken && (getAsoebiData?.getAseobi?.length ?? 0) > 0 && (
          <AsoEbi
            eventUuid={eventUuid}
            eventId={eventId}
            showAsoebi={accessToken ? true : false}
            // showAsoebi={true}
            showCashGift={!!accessToken && isCashGiftSetup}
            isCashGiftSetup={isCashGiftSetup}
            availableGiftPaymentCurrencies={
              eventBySlugData?.eventBySlug?.available_gift_payment_currencies ??
              []
            }
          />
        )}

        <MarqueeComp eventId={eventId} slugData={eventBySlugData} />

        <Vendors eventId={eventId} eventVendorData={eventVendorData} />

        <Footer slug={eventBySlugData} />
      </ClientOnly>
    </>
  );
};

export default HomeT11;
